// // PRODUCTION SERVER
export const BASE_URL = "https://tmsapi.raychemrpg.com/tms-core";

// // TESTING SERVER
// export const BASE_URL = "https://tmstesting.raychemrpg.com/tms-core";

// // export const BASE_URL = "http://tmstestingapi.scalent.io/tms-core";

// // Localhost
// export const BASE_URL = "http://localhost:8080/tms-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout API
export const LOGOUT = `${BASE_URL}/logout`;

// verify otp
export const VERIFY_OTP = `${BASE_URL}/verify-otp`;

// resend otp
export const RESEND_OTP = `${BASE_URL}/resend-otp`;

//visitor list
export const VISITOR_LIST = `${BASE_URL}/visitor/list`;
export const VISITOR = `${BASE_URL}/visitor/detail/`;

// trainee List
export const TRAINEE_LIST = `${BASE_URL}/trainee/list`;

// download QR code
export const DOWNLOAD_QR_CODE = `${BASE_URL}/trainee/download-qr/`;

//trainee details /add /edit /update
export const TRAINEE = `${BASE_URL}/trainee/`;


export const LETTER = `${BASE_URL}/letter/`;

export const LETTER_REQUEST_APPROVAL = `${BASE_URL}/letter/request-approval/`;

export const LETTER_TEMPLATE_CONTENT = `${BASE_URL}/letter-template-content/`

export const DELETE_LETTER_USER = `${BASE_URL}/letter-user/`;

export const DOWNLOAD_LETTER_QR = `${BASE_URL}/letter/qr/`;

export const DOWNLOAD_LETTER = `${BASE_URL}/letter/download`;

export const GENERATE_FINAL_LETTER = `${BASE_URL}/letter/generate/`;

// super admin api's
export const SA_LETTERS_LIST = `${BASE_URL}/sa/letters`;

export const SA_LETTER_APPROVAL = `${BASE_URL}/sa/letter-approval`;

export const DELETE_TOOL_ITEMS = `${BASE_URL}/letter/delete-tool-items`;

//channel-partner
export const CHANNEL_PARTNER = `${BASE_URL}/channel-partner/`;
export const CHANNEL_PARTNER_LIST = `${BASE_URL}/channel-partner/list`;

//city and state list
export const STATE_LIST = `${BASE_URL}/state/list`;
export const CITY_LIST = `${BASE_URL}/city/list`;

export const ADD_CITY = `${BASE_URL}/city/`;